
































import { DanosNonMadeirablesDTO } from '@/Application/Expediente'
import Vue from 'vue'

export default Vue.extend({
  name: 'WoodDamage',
  props: {
    dano: {
      type: DanosNonMadeirablesDTO || null,
      required: false
    }
  },
  computed: {
    reparacionDanos (): string {
      return this.dano !== null
        ? this.dano.reparacionDanos ? this.$t('shared.si').toString() : this.$t('shared.non').toString()
        : ''
    }
  }
})
